import AddSubsystemModal from '@/features/offers/components/Modal/AddSubsystemModal'
import AdminEditOfferModal from '@/features/offers/components/Modal/AdminEditOfferModal'
import ApprovalRemarkModal from '@/features/offers/components/Modal/ApprovalRemarkModal'
import CloneOfferModal from '@/features/offers/components/Modal/CloneOfferModal'
import CloseOfferModal from '@/features/offers/components/Modal/CloseOfferModal/CloseOfferModal'
import CreateOfferModal from '@/features/offers/components/Modal/CreateOfferModal'
import CreateTempVendorModal from '@/features/offers/components/Modal/CreateTempVendorModal'
import OfferReviseModal from '@/features/offers/components/Modal/OfferReviseModal/OfferReviseModal'
import OfferSourcingWorkflowModal from '@/features/offers/components/Modal/OfferSourcingWorkflowModal'
import PrintModal from '@/features/offers/components/Modal/PrintModal'
import PROnHoldConfirmationModal from '@/features/offers/components/Modal/PROnHoldConfirmationModal'
import ResubmitOfferModal from '@/features/offers/components/Modal/ResubmitOfferModal'
import SingleSourceProcurementModal from '@/features/offers/components/Modal/SingleSourceProcurementModal'
import SplitCostBudgetModal from '@/features/offers/components/Modal/SplitCostBudgetModal/SplitCostBudgetModal'

const OfferRouteWrapper = ({ children }) => {
  // Place to put all offer related Modal
  return (
    <>
      <AdminEditOfferModal />
      <OfferReviseModal />
      <CloneOfferModal />
      <CreateOfferModal />
      <AddSubsystemModal />

      <ResubmitOfferModal />
      <ApprovalRemarkModal />
      <PrintModal />
      <CreateTempVendorModal />
      <SingleSourceProcurementModal />
      <OfferSourcingWorkflowModal />
      <CloseOfferModal />
      <PROnHoldConfirmationModal />
      <SplitCostBudgetModal />

      {children}
    </>
  )
}

export default OfferRouteWrapper
